import {
  UPDATE_MIXINGPLANT_REQUEST,
  UPDATE_MIXINGPLANT_ERROR,
  UPDATE_MIXINGPLANT_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => async (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_MIXINGPLANT_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_MIXINGPLANT_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_MIXINGPLANT_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixingPlant";
  context.entityLocation = RESOURCES.MixingPlants;

  return context.execute(context)(entity, entityTableData)(state, action);
};